import { forwardRef, type HTMLAttributes, type ReactNode } from 'react'
import { cn } from '@/lib/utils'

/**
 * Sidebar — боковая навигация (`.sidebar` макета) фиксированной ширины из токенов.
 * Наполняется NavItem, Divider и NavGroup.
 */
export const Sidebar = forwardRef<HTMLElement, HTMLAttributes<HTMLElement>>(
  ({ className, children, ...props }, ref) => (
    <nav
      ref={ref}
      aria-label="Основная навигация"
      className={cn('w-sidebar shrink-0 border-r border-line bg-white px-2.5 py-3.5', className)}
      {...props}
    >
      {children}
    </nav>
  ),
)
Sidebar.displayName = 'Sidebar'

export interface NavGroupProps {
  /** Родительский пункт (обычно `NavLinkItem`) — кликабелен, ведёт на landing раздела. */
  parent: ReactNode
  /** Дочерние пункты (обычно `NavLinkItem[]`) — ВСЕГДА развёрнуты, без сворачивания/анимации. */
  children: ReactNode
}

/**
 * NavGroup — вложенная группа навигации 2 уровня (p2-ot-section, design D1): родитель + всегда
 * развёрнутые дочерние пункты с отступом. Новая возможность ДС — до этого сайдбар был только
 * плоским списком (`NavItem`); визуальный паттерн без прообраза в макете — разумный дефолт
 * (см. design.md Open Questions, донастройка возможна при дизайн-ревью без смены контракта).
 */
export function NavGroup({ parent, children }: NavGroupProps) {
  return (
    <div className="mb-0.5">
      {parent}
      <div className="ml-4 flex flex-col gap-0.5 border-l border-line py-0.5 pl-2">{children}</div>
    </div>
  )
}
